var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSilverStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60988_10548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.63862L7.64219 4.35203L6 0.226562L4.3578 4.35205L0 4.63865L3.34355 7.47294L2.24662 11.7779L6 9.40569L9.75338 11.7779L8.6565 7.47313L12 4.63862ZM6 8.5739L3.36412 10.2398L4.13351 7.22036L1.77724 5.22618L4.84688 5.02455L6 2.12772L7.15313 5.02457L10.2263 5.22618L7.86645 7.22017L8.63587 10.2398L6 8.5739Z",
    fill: "url(#paint0_linear_60988_10548)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_60988_10548",
    x1: 0.3,
    y1: 0.467216,
    x2: 10.8877,
    y2: 12.6606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A96AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#EAEFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopColor: "#C2D4E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491919,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.615,
    stopColor: "#D4DEE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "#ABBDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.955,
    stopColor: "#BCCAD7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60988_10548"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverStar);
export default __webpack_public_path__ + "static/media/silver_star.8611a34219d34332d4dc5f8fc13d754b.svg";
export { ForwardRef as ReactComponent };